import { render, staticRenderFns } from "./ShowPrices.vue?vue&type=template&id=12597aba"
import script from "./ShowPrices.vue?vue&type=script&lang=js"
export * from "./ShowPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports